<template>
  <!-- modal cadastro -->
  <b-modal id="modal-cadastrar" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 v-if="isEdicao" class="modal-title">Alterar usuário</h5>
      <h5 v-else class="modal-title">Cadastrar usuário</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastrar')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <h6><i class="fas fa-user-tag" /> Perfil</h6>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="perfil" class="sr-only">Perfil</label>
            <select id="perfil" class="form-control" v-model="usuario.perfil">
              <option :value="perfil.id" v-for="perfil in perfis">{{ perfil.nome }}</option>
            </select>
          </div>
        </div>
      </div>

      <h6><i class="fas fa-key" /> Dados de acesso</h6>
      <div class="row">
        <template v-if="isEdicao">
          <div class="col-12 col-md-9">
            <form-group id="usuario" label="Usuário *" :text="{ required: 'Obrigatório informar o e-mail' }"
                        :field="$v.usuario.email"
            >
              <input type="text" class="form-control" v-model="usuario.email" autocomplete="off">
            </form-group>
          </div>

          <div class="col-12 col-md-3" v-if="false">
            <form-group id="edit-usuario-senha" label="Senha" :text="{ required: 'Obrigatório informar a senha' }"
                        :field="$v.redefinicaoSenha.senha"
            >
              <input type="password" class="form-control" v-model="redefinicaoSenha.senha" autocomplete="off">
            </form-group>
          </div>

          <div class="col-12 col-md-3" v-if="false">
            <form-group id="edit-usuario-confirmar-senha" label="Confirmar senha"
                        :text="{ required: 'Obrigatório informar a confirmação da senha', sameAsSenha: 'As senhas não são iguais' }"
                        :field="$v.redefinicaoSenha.confirmacaoSenha"
            >
              <input type="password" class="form-control" v-model="redefinicaoSenha.confirmacaoSenha" autocomplete="off">
            </form-group>
          </div>

          <div class="col-12 col-md-3">
            <a href="javascript:void(0)" @click="redefinirSenha" class="btn btn-secondary mt-0 mt-md-3">Redefinir senha</a>
          </div>

          <div class="col-12">
            <div class="alert alert-info mt-3 mt-md-0" role="alert" v-html="mensagemRedefinicaoSenha" v-if="mensagemRedefinicaoSenha">
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-12 col-md-12">
            <form-group id="usuario"  label="Usuário *" :text="{ required: 'Obrigatório informar o e-mail do usuário', email: 'E-mail inválido' }"
                        :field="$v.usuario.email"
            >
              <input type="text" name="emailUsuarioCadastro" class="form-control" v-model="usuario.email" autocomplete="off">
            </form-group>
          </div>
        </template>
      </div>

      <h6><i class="fas fa-user" /> Dados pessoais</h6>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <form-group id="nome" label="Nome *" :text="{ required: 'Obrigatório informar o nome do usuário' }" :field="$v.usuario.nome">
              <input type="text" class="form-control" v-model="usuario.nome">
            </form-group>
          </div>
        </div>

        <div class="col-12 col-md-3">
          <div class="form-group">
              <form-group id="cpf" label="CPF" :text="{ minLength: 'CPF invalido' }" :field="$v.usuario.cpf">
                <input type="text" class="form-control" placeholder="000.000.000-00" v-mask="'###.###.###-##'" v-model="usuario.cpf">
              </form-group>
          </div>
        </div>

        <div class="col-12 col-md-3">
          <form-group id="nasc" label="Nascimento" :text="{ verificarNascimentoDataValida: 'Data de nascimento inválida' }" :field="$v.usuario.dataNascimento">
            <input type="text" class="form-control" placeholder="DD/MM/AAAA" v-mask="'##/##/####'" v-model="usuario.dataNascimento">
          </form-group>
        </div>

        <div class="col-12 col-md-8">
          <div class="form-group">
            <label for="end">Endereço</label>
            <input type="text" class="form-control" id="end" placeholder="" v-model="usuario.endereco.logradouro" />
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="form-group">
            <label for="complemento">Complemento</label>
            <input type="text" class="form-control" id="complemento" placeholder="" v-model="usuario.endereco.complemento" />
          </div>
        </div>

        <div class="col-12 col-md-3">
          <div class="form-group">
            <label for="cep">CEP</label>
            <input type="text" class="form-control" id="cep" v-mask="'#####-###'" v-model="usuario.endereco.cep" />
          </div>
        </div>

        <div class="col-12 col-md-2">
          <div class="form-group">
            <label for="uf">UF</label>
            <select class="form-control" id="uf" v-model="usuario.endereco.uf">
              <option value="">Selecione</option>
              <option :value="uf.id" v-for="uf in ufs">{{ uf.sigla }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="form-group">
            <label for="cidade">Cidade</label>
            <input type="text" class="form-control" id="cidade" v-model="usuario.endereco.cidade" />
          </div>
        </div>

        <div class="col-12 col-md-3">
          <div class="form-group">
            <label for="telefone">Telefone</label>
            <input type="text" class="form-control" id="telefone" v-mask="['(##) ####-####', '(##) #####-####']" v-model="usuario.telefone" />
          </div>
        </div>
      </div>

      <div class="row">
          <div class="col-12 col-md-12">
            <form-group id="infoAdicional" label="Informações Adicionais" :field="$v.usuario.infoAdicional">
              <ckeditor :editor="editor" class="ckeditor" :config="editorConfig" v-model="usuario.infoAdicional"></ckeditor>
            </form-group>
          </div>
        </div>

      <h6 v-if="isAlunoOuProfessor"><i class="fas fa-university" /> Dados acadêmicos</h6>
      <div class="row" v-if="isAlunoOuProfessor">
        <div class="col-12 col-md-12 form-group">
            <VueSelect v-model="usuario.faculdade_id" :reduce="faculdade => faculdade.id" :options="faculdades" :close-on-select="true" :clear-on-select="false"
            :preserve-search="true" placeholder="Selecione uma Universidade" label="faculdade" track-by="faculdade"
            select-label="Selecionar Universidade" deselect-label="Remover Universidade" selected-label="Universidade selecionada"
            :get-option-label="(faculdade) => faculdade.faculdade + ' - ' + faculdade.sigla"
            :preselect-first="true" :block-keys="['Tab','Enter']">
               <template #option="{ faculdade, sigla }">
                    {{ faculdade + ' - ' + sigla }}
                  </template>
                  <template slot="selection" slot-scope="{ values, search, isOpen }">
                    <span v-if="values.length &amp;&amp; !isOpen">{{ values }} Universidade selecionada</span>
                  </template>
                </VueSelect>
        </div>
      </div>

      <div class="row" v-if="isAlunoOuProfessor">
        <div class="col-12 col-md-3">
          <div class="form-group">
            <label for="graduacao">Curso</label>
            <select class="form-control" id="graduacao" v-model="usuario.graduacaoId">
              <option value="">Selecione</option>
              <option :value="graduacao.id" v-for="graduacao in graduacoes">{{ graduacao.nome }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-2" v-if="isAluno">
          <div class="form-group">
            <label for="per-atual">Período atual</label>
            <select class="form-control" id="per-atual" v-model="usuario.dadosfaculdade.periodo">
              <option value="1">1º</option>
              <option value="2">2º</option>
              <option value="3">3º</option>
              <option value="4">4º</option>
              <option value="5">5º</option>
              <option value="6">6º</option>
              <option value="7">7º</option>
              <option value="8">8º</option>
              <option value="9">9º</option>
              <option value="10">10º</option>
              <option value="11">11º</option>
              <option value="12">12º</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-4" v-if="isAluno">
          <div class="form-group">
            <label for="ano-inicio">Ano de início</label>
            <select class="form-control" id="ano-inicio" v-model="usuario.dadosfaculdade.anoInicio">
              <option v-for="anoInicio in montarAnosInicioFaculdade()" :value="anoInicio">{{anoInicio}}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-3" v-if="isAluno">
          <div class="form-group">
            <label for="per-atual">Semestre de início</label>
            <div class="form-check form-check-inline mt-2">
              <input class="form-check-input" type="radio" name="sem-inicio" id="semestre1" value="1" v-model="usuario.dadosfaculdade.semestre">
              <label class="form-check-label" for="semestre1">1</label>
            </div>
            <div class="form-check form-check-inline mt-2">
              <input class="form-check-input" type="radio" name="sem-inicio" id="semestre2" value="2" v-model="usuario.dadosfaculdade.semestre">
              <label class="form-check-label" for="semestre2">2</label>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-4" v-if="isProfessor">
          <div class="form-group">
            <label for="grau-formacao">Grau de formação</label>
            <select class="form-control" id="grau-formacao" v-model="usuario.dadosfaculdade.grauFormacao">
              <option value="1">Graduação</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-5" v-if="isProfessor">
          <div class="form-group">
            <label for="disciplina">Disciplina</label>
            <select class="form-control" id="disciplina" v-model="usuario.dadosfaculdade.disciplina">
              <option value="">Selecione</option>
              <option :value="disciplina.id" v-for="disciplina in disciplinas">{{ disciplina.nome }}</option>
            </select>
          </div>
        </div>
      </div>

      <div v-if="planos.length > 1">
        <h6><i class="fas fa-money-check"></i> Planos</h6>
        <div class="row">
          <div class="col-md-8">
            <form-group id="planos" label="Planos *" :text="{ required: 'Obrigatório informar o plano' }" :field="$v.planosSelecionados">
              <multiselect v-model="planosSelecionados" :options="planosOpcoes" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                           placeholder="Selecione um plano" label="plano" track-by="id" select-label="Selecionar plano" deselect-label="Remover plano"
                           selected-label="Plano selecionado" :preselect-first="false" :block-keys="['Tab','Enter']">
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} planos selecionados</span>
                </template>
              </multiselect>
              <div class="invalid-feedback" v-if="$v.planosSelecionados.$invalid">
                É obrigatório escolher ao menos um plano.
              </div>
            </form-group>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="editarUsuario" v-if="isEdicao">Salvar</button>
          <button class="btn btn-primary mr-3" type="button" @click="cadastrarUsuario" v-else>Cadastrar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Swal from 'sweetalert2'
import { required, email, minLength } from 'vuelidate/lib/validators'
import VueSelect from 'vue-select'
import CategoriaCursosAPI from '@/api/categorias-cursos-api'
import EnderecoAPI from '@/api/endereco-api'
import GraduacaoAPI from '@/api/graduacao-api'
import PlanoAPI from '@/api/plano-api'
import PerfilAPI from '@/api/perfil-api'
import UsuarioAPI from '@/api/usuario-api'
import FormGroup from '@/core/components/FormGroup'
import TipoCadasatro from '@/core/constants/tipoCadasatro'
import TipoPerfil, { TipoPerfilUtil } from '@/core/types/tipo-perfil'
import DateUtils, { DateConstants } from '@/core/util/date-utils'
import ResponseUtils from '@/core/util/response-utils'

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import Font from '@ckeditor/ckeditor5-font/src/font'
import Heading from '@ckeditor/ckeditor5-heading/src/heading'
import List from '@ckeditor/ckeditor5-list/src/list'
import Indent from '@ckeditor/ckeditor5-indent/src/indent'
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote'
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation'
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed'
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'

const verificarNascimentoDataValida = dataNascimento => {
  if (dataNascimento) {
    return DateUtils.verificarNascimentoDataValida(dataNascimento)
  }
  return true
}

export default {
  name: 'ModalCadastroUsuarioConta',
  components: { FormGroup, Multiselect, VueSelect },
  props: {
    usuarioEdicao: Number,
    faculdades: Array,
    planos: Array
  },
  data () {
    return {
      perfis: [],
      usuario: {
        perfil: 0,
        email: '',
        senha: '',
        nome: '',
        cpf: '',
        infoAdicional: '',
        graduacaoId: '',
        dataNascimento: '',
        endereco: {
          logradouro: '',
          complemento: '',
          cep: '',
          uf: '',
          cidade: ''
        },
        telefone: '',
        dadosfaculdade: {
          curso: 1,
          periodo: null,
          semestre: null,
          anoInicio: null,
          grauFormacao: 1,
          disciplina: ''
        },
        faculdade_id: '',
        faculdade_nome: ''
      },
      disciplinas: [],
      getItem: false,
      mensagemRedefinicaoSenha: '',
      graduacoes: [],
      ufs: [],
      planosOpcoes: [],
      planosSelecionados: [],
      planosEdicao: [],
      turmasSelecionadas: [],
      tipoCadastro: 0,
      editor: ClassicEditor,
      editorConfig: {
        plugins: [EssentialsPlugin, BoldPlugin, ItalicPlugin, LinkPlugin, ParagraphPlugin, Font, Heading, List, Indent, BlockQuote, PasteFromOffice, Table, TextTransformation, MediaEmbed, Autoformat, TableToolbar],
        toolbar: ['heading', '|', 'bold', 'italic', 'fontSize', 'fontColor', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'undo', 'redo']
      }
    }
  },

  computed: {
    isEdicao: function () {
      return this.usuarioEdicao && this.usuarioEdicao > 0
    },

    isAluno: function () {
      return TipoPerfil.ALUNO.id === this.usuario.perfil
    },

    isProfessor: function () {
      return TipoPerfil.PROFESSOR.id === this.usuario.perfil
    },

    isAlunoOuProfessor: function () {
      return this.isAluno || this.isProfessor
    }
  },

  async mounted () {
    CategoriaCursosAPI.listarDisciplinas().then(data => {
      this.disciplinas = data
    })

    EnderecoAPI.listarUFs().then(data => {
      this.ufs = data
    })

    this.graduacoes = await GraduacaoAPI.listar()

    PerfilAPI.listar().then(data => {
      this.perfis = data.map(item => TipoPerfilUtil.obterPorId(item.id)).sort((a, b) => a.ordem - b.ordem)
    })

    this.tipoCadastro = TipoCadasatro.B2C

    this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
      if (modalId === 'modal-cadastrar') {
        this.mensagemRedefinicaoSenha = ''
        this.$v.$reset()

        this.usuario = {
          perfil: 0,
          email: '',
          senha: '',
          nome: '',
          cpf: '',
          infoAdicional: '',
          graduacaoId: '',
          dataNascimento: '',
          endereco: {
            logradouro: '',
            complemento: '',
            cep: '',
            uf: '',
            cidade: ''
          },
          telefone: '',
          dadosfaculdade: {
            curso: 1,
            periodo: null,
            semestre: null,
            anoInicio: null,
            grauFormacao: 1,
            disciplina: ''
          },
          faculdade_id: '',
          faculdade_nome: ''
        }
        this.planosOpcoes = []
        this.planosSelecionados = []
        if (this.isEdicao) {
          const loader = this.$loading.show()

          this.planosEdicao = await PlanoAPI.listarPorUsuarioDaEmpresa(this.usuarioEdicao)

          if (this.planos.length === 1) {
            this.planosSelecionados.push(this.planos[0].plano)
          } else {
            this.planos.map(plano => {
              this.planosOpcoes.push(plano.plano)
            })
            this.planosEdicao.map(plano => {
              this.planosSelecionados.push(plano)
            })
          }

          UsuarioAPI.obterPorId(this.usuarioEdicao).then(data => {
            this.usuario = Object.assign({}, {
              id: data.id,
              perfil: data.perfil_id,
              email: data.email,
              nome: data.name,
              cpf: data.cpf,
              infoAdicional: data.informacao_extra,
              graduacaoId: data.graduacao_id,
              dataNascimento: data.data_nascimento ? DateUtils.formatDate(DateUtils.parse(data.data_nascimento), DateConstants.DD_MM_YYYY) : null,
              endereco: {
                logradouro: data.rua,
                complemento: data.complemento,
                cep: data.cep,
                uf: data.uf_id,
                cidade: data.cidade
              },
              telefone: data.telefone,
              dadosfaculdade: {
                curso: 1,
                periodo: data.periodo,
                semestre: data.semestre_inicio,
                anoInicio: data.ano_inicio,
                grauFormacao: 1
              },
              faculdade_id: data.faculdade_id,
              faculdade_nome: data.faculdade ? data.faculdade.faculdade + ' - ' + data.faculdade.sigla : null,
              turmas: data.turmas
            })
            this.turmasSelecionadas = this.usuario.turmas
            loader.hide()
          })
        } else {
          this.usuario.perfil = this.perfis[0].id
          if (this.planos.length === 1) {
            this.planosSelecionados.push(this.planos[0].plano)
          } else {
            this.planos.map(plano => {
              this.planosOpcoes.push(plano.plano)
            })
          }
        }
      }
    })
  },

  validations: {
    usuario: {
      email: { required, email },
      nome: { required },
      cpf: { minLength: minLength(14) },
      dataNascimento: { verificarNascimentoDataValida },
      infoAdicional: { }
    },
    planosSelecionados: { required }
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-cadastrar')
    },

    montarAnosInicioFaculdade: function () {
      const limiteAnos = 11

      let anosFormacao = []
      let year = new Date().getFullYear()

      for (let i = 0; i < limiteAnos; i++) {
        anosFormacao.push(year--)
      }

      return anosFormacao
    },

    cadastrarUsuario: function () {
      this.$v.usuario.$touch()
      if (!this.$v.usuario.$invalid && !this.$v.planosSelecionados.$invalid) {
        const loader = this.$loading.show()

        const usuario = {
          perfil_id: this.usuario.perfil,
          email: this.usuario.email,
          password: this.usuario.senha,
          name: this.usuario.nome,
          cpf: this.usuario.cpf,
          infoAdicional: this.usuario.infoAdicional,
          data_nascimento: this.usuario.dataNascimento ? DateUtils.formatDate(DateUtils.parse(this.usuario.dataNascimento, 'DD/MM/YYYY')) : null,
          rua: this.usuario.endereco.logradouro,
          complemento: this.usuario.endereco.complemento,
          cep: this.usuario.endereco.cep,
          uf_id: this.usuario.endereco.uf,
          graduacao_id: this.usuario.graduacaoId,
          cidade: this.usuario.endereco.cidade,
          telefone: this.usuario.telefone ? this.usuario.telefone.replace(/ |-|\.|\(|\)|\+/g, '') : null,
          curso: 1,
          periodo: this.isAluno ? this.usuario.dadosfaculdade.periodo : null,
          semestre_inicio: this.isAluno ? this.usuario.dadosfaculdade.semestre : null,
          ano_inicio: this.isAluno ? this.usuario.dadosfaculdade.anoInicio : null,
          faculdade_id: this.usuario.faculdade_id,
          planos: this.planosSelecionados,
          turmasSelecionadas: this.turmasSelecionadas,
          tipo_origem_cadastro_id: this.tipoCadastro
        }

        UsuarioAPI.salvar(usuario).then(() => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Usuário criado com sucesso'
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar')
            this.$emit('usuarioSalvo', this.usuario)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },

    editarUsuario: function () {
      this.$v.usuario.$touch()
      if (!this.$v.usuario.$invalid) {
        const loader = this.$loading.show()

        const usuario = {
          id: this.usuarioEdicao,
          perfil_id: this.usuario.perfil,
          email: this.usuario.email,
          name: this.usuario.nome,
          cpf: this.usuario.cpf,
          infoAdicional: this.usuario.infoAdicional,
          data_nascimento: this.usuario.dataNascimento ? DateUtils.formatDate(DateUtils.parse(this.usuario.dataNascimento, DateConstants.DD_MM_YYYY)) : null,
          rua: this.usuario.endereco.logradouro,
          complemento: this.usuario.endereco.complemento,
          cep: this.usuario.endereco.cep,
          uf_id: this.usuario.endereco.uf,
          graduacao_id: this.usuario.graduacaoId,
          cidade: this.usuario.endereco.cidade,
          telefone: this.usuario.telefone ? this.usuario.telefone.replace(/ |-|\.|\(|\)|\+/g, '') : null,
          curso: 1,
          periodo: this.isAluno ? this.usuario.dadosfaculdade.periodo : null,
          semestre_inicio: this.isAluno ? this.usuario.dadosfaculdade.semestre : null,
          ano_inicio: this.isAluno ? this.usuario.dadosfaculdade.anoInicio : null,
          faculdade_id: this.usuario.faculdade_id,
          planos: this.planosSelecionados,
          planosUsuario: this.planosEdicao,
          turmasSelecionadas: this.turmasSelecionadas
        }

        UsuarioAPI.editar(usuario).then(() => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Usuário atualizado com sucesso!'
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar')
            this.$emit('usuarioSalvo', this.usuario)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },

    redefinirSenha: function () {
      const loader = this.$loading.show()

      UsuarioAPI.redefinirSenha(this.usuario.id).then(() => {
        this.mensagemRedefinicaoSenha = `Enviado e-mail de redefinição de senha para o usuário <strong>${this.usuario.email}</strong>!`
      }).catch(error => ResponseUtils.handleError(error, loader))
        .then(() => loader.hide())
    }
  },
  watch: {
    getItem: function () {
      if (this.getItem) {
        this.usuario.faculdade_id = this.getItem.id
      }
    }
  }
}
</script>

<style>
select#disciplina {
  text-transform: capitalize;
}
</style>
